import Vue from "vue";

// Ein gemeinsames Mouseover-Fenster am body fuer die ganze Seite (Karte "Lieferplan / Meldung bei Mouse Over").
// md-tooltip meldet sich nur einmal beim Mounten am Elternelement an; tauscht die Tabelle nach einem Live-Update
// die Zeilen aus, haengt es am alten Element und bleibt stumm. Hier haengen die Listener immer am aktuellen
// Element, und das Fenster lebt unabhaengig von der Tabelle. Anders als das title-Attribut erscheint es auch,
// wenn das Browserfenster gerade nicht aktiv ist.

const GAP = 10;
const MARGIN = 4;

let popup = null;
let watchTimer = null;

function instance() {
  if (popup) return popup;
  popup = new Vue({
    data: () => ({ trigger: null, content: null, text: "", visible: false, ready: false, top: 0, left: 0, placement: "top", extraClass: "" }),
    render(h) {
      const children = !this.visible ? [] : this.content ? this.content() : this.text;
      return h(
        "div",
        {
          class: ["md-tooltip", "md-theme-default", "hover-tip-popup", this.content ? "" : "hover-tip-popup--text", this.extraClass],
          attrs: { "x-placement": this.placement },
          style: {
            display: this.visible ? "block" : "none",
            visibility: this.ready ? "visible" : "hidden",
            top: `${this.top}px`,
            left: `${this.left}px`,
          },
        },
        children
      );
    },
  });
  popup.$mount();
  document.body.appendChild(popup.$el);
  // Beim Scrollen wuerde das Fenster vom Element wegwandern
  window.addEventListener("scroll", () => hideHoverTip(), true);
  return popup;
}

function place(p, wanted) {
  const rect = p.trigger.getBoundingClientRect();
  const w = p.$el.offsetWidth;
  const h = p.$el.offsetHeight;
  let placement = wanted;
  let top = wanted === "bottom" ? rect.bottom + GAP : rect.top - h - GAP;
  if (placement === "top" && top < MARGIN) {
    placement = "bottom";
    top = rect.bottom + GAP;
  } else if (placement === "bottom" && top + h > window.innerHeight - MARGIN && rect.top - h - GAP >= MARGIN) {
    placement = "top";
    top = rect.top - h - GAP;
  }
  const left = Math.min(Math.max(rect.left + rect.width / 2 - w / 2, MARGIN), window.innerWidth - w - MARGIN);
  p.placement = placement;
  p.top = Math.round(top);
  p.left = Math.round(left);
  p.ready = true;
}

/**
 * Zeigt das Mouseover an einem Element.
 * @param {HTMLElement} trigger Element, an dem das Fenster ausgerichtet wird.
 * @param {{ content?: Function, text?: string, placement?: string, className?: string }} options
 *   content liefert VNodes (Slot), sonst wird text als Klartext (Zeilenumbrueche bleiben) gezeigt.
 */
export function showHoverTip(trigger, options) {
  const p = instance();
  const wanted = options.placement || "top";
  p.trigger = trigger;
  p.content = options.content || null;
  p.text = options.text || "";
  p.extraClass = options.className || "";
  p.placement = wanted;
  p.ready = false;
  p.visible = true;
  p.$forceUpdate();
  p.$nextTick(() => {
    if (p.trigger === trigger && p.visible) place(p, wanted);
  });
  // Verschwindet das Element (Tabelle neu geladen), kommt kein mouseleave mehr
  clearInterval(watchTimer);
  watchTimer = setInterval(() => {
    if (!p.trigger || !document.body.contains(p.trigger)) hideHoverTip();
  }, 300);
}

/** Aktualisiert den Klartext, falls das Fenster gerade an diesem Element steht. */
export function updateHoverTipText(trigger, text) {
  if (popup && popup.visible && popup.trigger === trigger) popup.text = text || "";
}

/** Blendet das Fenster aus; mit trigger nur, wenn es gerade an diesem Element steht. */
export function hideHoverTip(trigger) {
  if (!popup || (trigger && popup.trigger !== trigger)) return;
  popup.visible = false;
  popup.ready = false;
  popup.trigger = null;
  popup.content = null;
  clearInterval(watchTimer);
  watchTimer = null;
}
